export default __webpack_public_path__ + "static/media/matchup.754be78d.png";